var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"container-xs"},[_c('v-img',{staticClass:"mx-auto",attrs:{"src":require('@/assets/cover.png'),"width":"50%"}}),_c('v-divider'),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }